import ms from 'ms';
import extend from 'extend';
import { MS_YEAR } from '@/const';

const baseFormat = new Intl.NumberFormat(undefined, {
    maximumFractionDigits: 2
});

export default {
    methods: {
        formatNumber (input, digits) {
            if (typeof input === 'number') {
                if (typeof digits === 'number') {
                    input = input.toFixed(digits);
                } else {
                    if (input < 10) {
                        input = input.toFixed(2);
                    } else if (input < 100) {
                        input = input.toFixed(1);
                    } else {
                        input = input.toFixed(0);
                    }
                }
            }

            return baseFormat.format(input);
        },
        formatTime (input, options = {}) {
            if (input < MS_YEAR) {
                options = extend({
                    long: true
                }, options);

                return ms(input, options);
            } else {
                var years = (input / MS_YEAR);
                return this.formatNumber(years) + ' ' + ((years !== 1) ? 'years' : 'year');
            }
        },
        formatUnit (data) {
            return this.formatNumber(data.value) + data.unit.abbr;
        }
    }
};
